import { DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PageTitleService } from '@core/services/page-title.service';
import { TranslateService } from '@ngx-translate/core';

export function createPageTitleSetter(pageTitleService: PageTitleService) {
  return (translationKey: string, fallback?: string) => {
    pageTitleService.setTitle(translationKey, fallback);
  };
}

export function usePageTitle() {
  const pageTitleService = inject(PageTitleService);
  return (translationKey: string, fallback?: string) => {
    pageTitleService.setTitle(translationKey, fallback);
  };
}

export function usePageTitleWithLangChange() {
  const pageTitleService = inject(PageTitleService);
  const translateService = inject(TranslateService);
  const destroyRef = inject(DestroyRef);

  return (translationKey: string, fallback?: string) => {
    pageTitleService.setTitle(translationKey, fallback);

    // Update title on language changes
    translateService.onLangChange
      .pipe(takeUntilDestroyed(destroyRef))
      .subscribe(() => {
        pageTitleService.setTitle(translationKey, fallback);
      });
  };
}

export const PAGE_TITLES = {
  ERROR: { key: 'page.error.title', fallback: 'Questback - Error' },
  GDPR: { key: 'page.gdpr.title', fallback: 'Questback - GDPR' },
  INFORMATION: {
    key: 'page.information.title',
    fallback: 'Questback - Information',
  },
  INVITATION: {
    key: 'page.invitation.title',
    fallback: 'Questback - Invitation',
  },
  LANGUAGE: { key: 'page.language.title', fallback: 'Questback - Language' },
  PASSWORD: { key: 'page.password.title', fallback: 'Questback - Password' },
  PREVIEW: { key: 'page.preview.title', fallback: 'Questback - Preview' },
  PRINT: { key: 'page.print.title', fallback: 'Questback - Print' },
  START_OVER: {
    key: 'page.startover.title',
    fallback: 'Questback - Start Over',
  },
  GOTO_PAGE: {
    key: 'page.gotopage.title',
    fallback: 'Questback - Redirect to question',
  },
  SURVEY: { key: 'page.survey.title', fallback: 'Questback - Survey' },
  THEME: { key: 'page.theme.title', fallback: 'Questback - Theme' },
} as const;
